import { NextRouter, useRouter } from "next/router";
import { Dictionary } from "@/types/filtres";

export const formatParamsToArray = (query: string) => {
    const paramsList = [...new URLSearchParams(query)];
    const params: Dictionary = {};
    paramsList.forEach((keyVal) => {
        try {
            const [key, value] = keyVal;
            if (value.includes(",")) {
                params[key] = value.split(",").map(Number);
            } else params[key] = JSON.parse(value);
        } catch {
            // ignore param
        }
    });

    return params;
};

export const formatQueryString = (params: Dictionary) => {
    const newSearch = Object.keys(params)
        .filter((key) => params[key])
        .map((key) => formatParam(params, key));

    return newSearch.join("&").replace(/"/g, "");
};

const formatParam = (params: Dictionary, key: string) => {
    if (Array.isArray(params[key])) {
        return params[key].map((value, index) => `${index > 0 ? "&" : ""}${key}=${value}`).join("");
    }
    return `${key}=${JSON.stringify(params[key])}`;
};

const getSetQueryString = (router: NextRouter, params: Dictionary, param: object) => {
    const { asPath } = router;
    const newParams = {
        ...params,
        ...param,
    } as Dictionary;

    const basePathUrl = String(asPath).split("?")[0];
    const newSearch = formatQueryString(newParams);

    router.push(`${basePathUrl}?${newSearch}`);
};

const removeQueryParam = (router: NextRouter, params: Dictionary, key: string) => {
    const { asPath } = router;
    const newParams = { ...params };
    delete newParams.key;

    const basePathUrl = String(asPath).split("?")[0];
    const newSearch = formatQueryString(newParams);

    router.push(`${basePathUrl}?${newSearch}`);
};

const useQueryString = () => {
    const router = useRouter();
    const { query } = router;

    const params = formatParamsToArray(query.toString());

    return {
        getQueryString: () => params,
        setQueryString: (param: Dictionary) => getSetQueryString(router, params, param),
        removeQueryParam: (key: string) => removeQueryParam(router, params, key),
        formatQueryString,
    };
};

export default useQueryString;
